module.exports = __webpack_public_path__ + "img/category-title03-m.d07dff3f.png";